const he = {
    general: {
        notAvailable: 'לא זמין',
    },
    tableRanges: {
        start: 'התחלה',
        end: 'סיום',
        month: 'חודש',
        hour: 'שעה',
    },
    months: {
        short: {
            jan: 'ינו׳',
            feb: 'פבר׳',
            mar: 'מרץ',
            apr: 'אפר׳',
            may: 'מאי',
            jun: 'יונ׳',
            jul: 'יול׳',
            aug: 'אוג׳',
            sep: 'ספט׳',
            oct: 'אוק׳',
            nov: 'נוב׳',
            dec: 'דצמ׳',
        },
    },
    hello: 'שלום',
    header: {
        title: 'מערכת ניהול אנרגיה',
        search: 'חיפוש...',
        superUser: 'מנהל כללי',
        back: 'חזור',
        profile: {
            profile: 'פרופיל',
            settings: 'הגדרות',
            myAccount: 'החשבון שלי',
            logout: 'התנתק',
        },
    },
    login: {
        email: 'כתובת מייל',
        password: 'סיסמא',
        submit: 'כניסה',
        title: 'התחברות',
        subtitle: 'נהלו, נתחו ואופטמו את צריכת האנרגיה שלכם בביטחון.',
        welcome: 'ברוכים השבים! הזינו את הפרטים שלכם.',
        hero_title: 'ניהול אנרגיה חכם לארגונים מודרניים',
        highlight_1: 'לוחות מחוונים בזמן אמת ואנליטיקה מתקדמת',
        highlight_2: 'גישה מאובטחת מותאמת לארגון שלכם',
        error: 'כתובת מייל או סיסמא אינם נכונים',
        buttonNavigate: 'לחץ כאן לאיפוס סיסמא',
        success: 'התחברת בהצלחה',
    },
    two_factor: {
        title: 'נדרש אימות',
        submit: 'אמת',
        code: 'קוד אימות',
        error: 'קוד שגוי או שפג תוקפו. אנא נסו שוב.',
        codeSent: 'קוד האימות נשלח לכתובת המייל שלכם',
        welcome: 'קוד בן 6 ספרות נשלח לכתובת המייל שלכם.',
    },
    side_menu: {
        sites: 'אתרים',
        users: 'משתמשים',
        structures: 'מבנים',
        meters: 'מונים',
        consumers: 'צרכנים',
        rates: 'תעריפים',
        dashboard: 'כללי',
        meter_readings: 'יומן קריאות',
        fault_logs: 'יומן תקלות',
        invoices: 'יומן חשבונות',
        account_reports: 'דוחות חשבונות',
        invites: 'הזמנת משתמשים',
        select_site: 'בחר אתר',
        clear_site: 'נקה בחירה',
        payments: 'תשלומים',
        queue_jobs: 'עבודות תור',
        categories: {
            management: 'ניהול',
            billing: 'חיוב',
            system: 'מערכת',
        },
    },
    dashboard: {
        currentRate: 'התעריף הנוכחי',
        current_rate_subtitle: 'התעריפים הפעילים החלים על החשבון שלך.',
        readingsCard: {
            title: 'סקירת קריאות מונה',
            totalReadings: 'סה"כ קריאות מונה שנאספו היום',
            successRate: 'אחוז הצלחה',
            lastUpdated: 'עדכון אחרון',
            successful: 'מוצלחות',
            failed: 'נכשלו',
        },
        invoices_cost_title: 'תחזית עלות וחיסכון',
        invoices_cost_subtitle: 'סכומי חשבוניות חודשיים לפי אתרים או צרכנים פעילים.',
        invoices_cost_empty: 'אין נתוני חשבוניות להצגה במבט זה.',
        invoices_cost_month_series: 'עלות חודשית',
        invoices_cost_total_series: 'סה"כ מצטבר',
        invoices_cost_ytd_series: 'עלות מצטברת',
        invoices_cost_ytd_title: 'סה"כ מצטבר מתחילת השנה',
        noRateAvailable: 'אין תעריף זמין',
    },
    sites: {
        _id: 'מזהה',
        name: 'שם',
        apiKey: 'מפתח',
        created: 'תאריך יצירה',
        updated: 'תאריך עדכון',
        location: 'מיקום',
        dayOfMonth: 'יום לחיוב',
        createAccount: 'צור אתר',
        editAccount: 'ערוך אתר',
        security: 'אבטחה',
        isTwoFactorAuth: 'דרוש אימות דו-שלבי',
        rates: 'תעריפים',
        serviceRate: 'תעריף שירות',
        electricityRate: 'תעריף חשמל',
        waterRate: 'תעריף מים',
        gasRate: 'תעריף גז',
        payment: 'תשלום',
        terminalName: 'שם טרמינל',
        paymentProvider: 'ספק תשלום',
        configs: 'קונפיגורציות',
        submit: {
            edit: {
                success: 'אתר עודכן בהצלחה',
                error: 'שגיאה בעדכון אתר',
            },
            create: {
                success: 'אתר נוצר בהצלחה',
                error: 'שגיאה ביצירת אתר',
            },
        },
        delete: {
            success: 'אתר נמחק בהצלחה',
            error: 'שגיאה במחיקת אתר',
        },
        accountSelect: 'בחר אתר',
    },
    userAccounts: {
        title: 'אתר מקושר',
        account: 'אתר',
        role: 'הרשאות',
        confirmed: 'מאושר',
    },
    users: {
        _id: 'מזהה',
        name: 'שם',
        email: 'מייל',
        status: 'מצב',
        role: 'הרשאות',
        firstName: 'שם פרטי',
        lastName: 'שם משפחה',
        phone: 'טלפון',
        account: 'אתר',
        password: 'סיסמא',
        confirmPassword: 'אימות סיסמא',
        createUser: 'צור משתמש',
        editUser: 'ערוך משתמש',
        userAccounts: 'אתרים מקושרים',
        users: 'משתמשים',
        invites: 'הזמנות',
        submit: {
            edit: {
                success: 'משתמש עודכן בהצלחה',
                error: 'שגיאה בעדכון משתמש',
            },
            create: {
                success: 'משתמש נוצר בהצלחה',
                error: 'שגיאה ביצירת משתמש',
            },
        },
        delete: {
            success: 'משתמש נמחק בהצלחה',
            error: 'שגיאה במחיקת משתמש',
        },
        accountSelect: 'בחר אתר',
    },
    structures: {
        _id: 'מזהה',
        name: 'שם',
        account: 'אתר',
        location: 'מיקום',
        createStructure: 'צור מבנה',
        editStructure: 'ערוך מבנה',
        submit: {
            edit: {
                success: 'מבנה עודכן בהצלחה',
                error: 'שגיאה בעדכון מבנה',
            },
            create: {
                success: 'מבנה נוצר בהצלחה',
                error: 'שגיאה ביצירת מבנה',
            },
        },
        delete: {
            success: 'מבנה נמחק בהצלחה',
            error: 'שגיאה במחיקת מבנה',
        },
        accountSelect: 'בחר אתר',
    },
    meters: {
        _id: 'מזהה',
        name: 'שם',
        account: 'אתר',
        structure: 'מבנה',
        type: 'סוג מונה',
        input: 'כניסה',
        meter: 'מזהה מונה',
        inputType: 'סוג כניסה',
        createMeter: 'צור מונה',
        consumer: 'צרכן',
        editMeter: 'ערוך מונה',
        meterReading: 'תאריך קריאה אחרון',
        category: 'קטגורית מונה',
        conversionRate: 'שער המרה',
        rolloverValue: 'ערך גלגול',
        meterId: 'מזהה מונה',
        settings: 'הגדרות',
        additionalCharges: 'חיובים נוספים',

        relationshipUpdates: 'עדכוני שיוך',
        consumerUpdateDate: 'תאריך עדכון צרכן',
        structureUpdateDate: 'תאריך עדכון מבנה',
        consumerUpdateDateAction: 'הוסף תאריך עדכון צרכן',
        structureUpdateDateAction: 'הוסף תאריך עדכון מבנה',
        updateDateTooltipWithValue: '{{field}} מוגדר ל-{{value}}. לחץ לשינוי.',
        active: 'פעיל',
        provider: 'ספק',
        submit: {
            edit: {
                success: 'מונה עודכן בהצלחה',
                error: 'שגיאה בעדכון מונה',
            },
            create: {
                success: 'מונה נוצר בהצלחה',
                error: 'שגיאה ביצירת מונה',
            },
        },
        delete: {
            success: 'מונה נמחק בהצלחה',
            error: 'שגיאה במחיקת מונה',
        },
        sync: {
            success: 'סנכרון מונה הופעל',
            error: 'שגיאה בהפעלת סנכרון מונה',
        },
        syncZeusintDaily: 'סנכרון Zeusint יומי',
        syncZeusintDailySuccess: 'סנכרון Zeusint יומי הופעל',
        syncZeusintDailyError: 'שגיאה בהפעלת סנכרון Zeusint יומי',
        error: {
            charge_key_max: 'שם חיוב יכול להכיל עד 100 תווים',
            duplicate_charge_key:
                'שמות החיובים חייבים להיות ייחודיים (ללא תלות באותיות גדולות/קטנות)',
        },
        accountSelect: 'בחר אתר',
    },
    consumers: {
        _id: 'מזהה',
        name: 'שם',
        email: 'מייל',
        phone: 'טלפון',
        account: 'אתר',
        structure: 'מבנה',
        charging_date: 'תאריך חיוב',
        taoz: 'תעוז',
        meter: 'מונה',
        location: 'מיקום',
        createConsumer: 'צור צרכן',
        last_invoice_date: 'תאריך חשבון אחרון',
        payment: 'תשלום',
        send_unpaid_invoices: {
            success: 'תזכורת על חשבוניות שלא שולמו נשלחה בהצלחה',
            error: 'שגיאה בשליחת תזכורת על חשבוניות שלא שולמו',
            confirm: 'האם אתה בטוח שברצונך לשלוח לצרכן תזכורת על חשבוניות שלא שולמו?',
        },
        submit: {
            edit: {
                success: 'צרכן עודכן בהצלחה',
                error: 'שגיאה בעדכון צרכן',
            },
            create: {
                success: 'צרכן נוצר בהצלחה',
                error: 'שגיאה ביצירת צרכן',
            },
        },
        delete: {
            success: 'צרכן נמחק בהצלחה',
            error: 'שגיאה במחיקת צרכן',
        },
        accountSelect: 'בחר אתר',
    },
    rates: {
        _id: 'מזהה',
        rate: 'תעריף',
        monthStart: 'חודש התחלה',
        monthEnd: 'חודש סיום',
        hourStart: 'שעת התחלה',
        hourEnd: 'שעת סיום',
        months: 'חודשים',
        hours: 'שעות',
        typeDay: 'סוג יום',
        status: 'מצב',
        account: 'אתר',
        name: 'שם',
        rateSection: 'צור תעריף',
        editRate: 'ערוך תעריף',
        settings: 'הגדרות',
        isGlobal: 'תעריף כללי',
        global_label: 'תעריף גלובלי',
        category: 'קטגורית מונה',
        dateAndTimeSection: 'תאריך ושעה',
        calendar: {
            action: 'יצירת תעריף בלוח שנה',
            title: 'יצירת תעריף (לוח שנה)',
            instructions: 'בחר את החודשים והשעות לתעריף באמצעות גרירה על פני הרשת.',
            tips: {
                drag: 'גרור כדי לבחור טווח',
                remove: 'לחיצה ימנית וגרירה להסרת טווח',
            },
            form: {
                settingsTitle: 'הגדרות תעריף',
                settingsHint: 'בחר חשבון, קטגוריה ופרטי תעריף לפני בחירת המשבצות בלוח.',
                infoTitle: 'סטטוס הלוח',
                infoHint: 'הספירות מתעדכנות אוטומטית כאשר אתה מוסיף או מסיר משבצות.',
                selectionLabel: 'משבצות בהמתנה',
                lockedLabel: 'משבצות נעולות',
                hoverLabel: 'משבצות נעולות מודגשות',
                hoverHint:
                    'המשבצות האפורות שייכות לתעריפים פעילים. ריחוף מציג את כל הטווח וקליק מאפשר ניהול התעריף.',
                summaryTitle: 'סיכום בחירה',
                emptySummary: 'לא נבחרו משבצות.',
            },
            legend: {
                active: 'טווח שנבחר',
                previewAdd: 'גרירה להוספה',
                previewRemove: 'גרירה להסרה',
            },
            selection: {
                empty: 'בחר טווח זמן כדי לראות כאן את הסיכום.',
                single: 'נבחר {{month}} בשעה {{hour}}.',
                sameMonth: 'נבחר {{month}} בין {{startHour}} ל-{{endHour}}.',
                multiMonth: 'נבחר {{startMonth}} {{startHour}} ועד {{endMonth}} {{endHour}}.',
                count: '{{count}} משבצות זמן נבחרו (ראשונה: {{month}} {{hour}}).',
            },
            clear: 'איפוס בחירה',
            save: 'שמור תעריף',
            saving: 'שומר...',
            cancel: 'בטל',
            gridTitle: 'פריסת חודשים ושעות',
            aria: {
                grid: 'לוח שנה לתעריף. גרירה לבחירת חודשים ושעות מתאימים.',
                cell: '{{month}} בשעה {{hour}}',
            },
            lockedRate: {
                title: 'תעריף קיים',
                description: 'טווח שעות זה שייך לתעריף פעיל קיים.',
                typeDay: 'סוג יום',
                rate: 'תעריף: {{value}}',
                months: 'חודשים',
                hours: 'שעות',
                disable: 'בטל תעריף',
                disabling: 'מעדכן תעריף…',
                disableSuccess: 'התעריף בוטל בהצלחה.',
                disableError: 'אירעה שגיאה בעת ביטול התעריף.',
                none: 'אין',
                tooltipTitle: 'תעריף פעיל',
                tooltipRate: 'תעריף: {{value}}',
                tooltipDay: 'סוג יום: {{value}}',
            },
            preview: {
                actionButton: 'תצוגה מקדימה',
                title: 'תצוגה מקדימה של לוח התעריפים',
                subtitle: 'סנן וצפה בתעריפי החשמל שהוגדרו ללא אפשרות עריכה.',
                filtersTitle: 'מסננים',
                accountLabel: 'אתר',
                allAccounts: 'כל האתרים',
                typeDayLabel: 'סוג יום',
                rateNameLabel: 'שם תעריף',
                noRateSelected: 'לא נבחר תעריף',
                allRates: 'כל שמות התעריפים',
                clearRates: 'נקה בחירה',
                selectAllRates: 'בחר הכל',
                isGlobalLabel: 'תחולה',
                isGlobalAll: 'כל התעריפים',
                isGlobalOnly: 'תעריפים כלליים בלבד',
                isGlobalLocal: 'תעריפי אתרים בלבד',
                resultsSummary: '{{count}} תעריפים נמצאו',
                noRatesTitle: 'לא נמצאו תעריפים',
                noRatesDescription: 'נסה לשנות את המסננים כדי לראות תעריפים על גבי הלוח.',
                dialogTitle: 'פרטי התעריף',
                dialogDescription: 'תצוגה מקדימה בלבד - לא ניתן לערוך בחלון זה.',
            },
        },
        submit: {
            edit: {
                success: 'תעריף עודכן בהצלחה',
                error: 'שגיאה בעדכון תעריף',
            },
            create: {
                success: 'תעריף נוצר בהצלחה',
                error: 'שגיאה ביצירת תעריף',
            },
        },
        delete: {
            success: 'תעריף נמחק בהצלחה',
            error: 'שגיאה במחיקת תעריף',
        },
        accountSelect: 'בחר אתר',
    },
    meter_readings: {
        _id: 'מזהה',
        account: 'אתר',
        meter: 'מונה',
        date: 'תאריך קריאה',
        value: 'ערך',
        absolute_value: 'ערך מוחלט',
        price: 'מחיר',
        name: 'שם',
        structure: 'מבנה',
        createMeterReading: 'צור קריאה',
        editMeterReading: 'ערוך קריאה',
        failure_details: 'סיבת תקלה',
        status: 'מצב',
        submit: {
            edit: {
                success: 'קריאת מונה עודכנה בהצלחה',
                error: 'שגיאה בעדכון קריאת מונה',
            },
            create: {
                success: 'קריאת מונה נוצרה בהצלחה',
                error: 'שגיאה ביצירת קריאת מונה',
            },
        },
        updateValue: {
            success: 'קריאת מונה עודכנה בהצלחה',
            error: 'שגיאה בעדכון קריאת מונה',
        },
        delete: {
            success: 'קריאת מונה נמחקה בהצלחה',
            error: 'שגיאה במחיקת קריאת מונה',
        },
        export: {
            title: 'ייצוא לאקסל',
            button: 'ייצוא',
            from_date: 'מתאריך',
            to_date: 'עד תאריך',
            success: 'הקובץ יוצא בהצלחה',
            error: 'שגיאה בייצוא הקובץ',
        },
        accountSelect: 'בחר אתר',
    },
    invoices: {
        _id: 'מזהה',
        account: 'אתר',
        consumer: 'צרכן',
        meter: 'מונה',
        from_date: 'זמן התחלה',
        to_date: 'זמן סיום',
        send_mail: 'שלח מייל',
        created: 'זמן הנפקה',
        total_price: 'סה"כ',
        createInvoice: 'צור חשבון',
        download: {
            success: 'הורדת חשבון בהצלחה',
            error: 'שגיאה בהורדת חשבון',
        },
        is_paid: 'שולם',
        createPdfSuccess: 'חשבונית נוצרה בהצלחה',
        createPdfError: 'שגיאה ביצירת חשבונית',
        is_change_status: 'שנה מצב',
        resend: {
            success: 'החשבונית נשלחה מחדש בהצלחה',
            error: 'שגיאה בשליחת החשבונית מחדש',
            confirm: 'האם אתה בטוח שברצונך לשלוח את החשבונית מחדש?',
        },
        cancel: {
            success: 'החשבונית בוטלה בהצלחה',
            error: 'שגיאה בביטול החשבונית',
            confirm: 'האם אתה בטוח שברצונך לבטל את החשבונית?',
        },
        cancelled_status: 'חשבונית בוטלה',
        invoice_number: 'חשבון מספר',
        creation_method: 'שיטת הפקה',
        is_paid_status: {
            true: 'שולם',
            false: 'לא שולם',
            confirm_text: {
                paid: 'כן, סמן כשולם',
                unpaid: 'כן, סמן כלא שולם',
            },
            close_modal_title: {
                paid: 'האם אתה בטוח שברצונך לסמן את החשבון כשולם?',
                unpaid: 'האם אתה בטוח שברצונך לסמן את החשבון כלא שולם?',
            },
            success: {
                paid: 'החשבונית סומנה כשולמה בהצלחה',
                unpaid: 'החשבונית סומנה כלא שולמה בהצלחה',
            },
        },
        number: 'מספר חשבון',
        submit: {
            edit: {
                success: 'חשבונית עודכנה בהצלחה',
                error: 'שגיאה בעדכון חשבונית',
            },
            create: {
                success: 'חשבונית נוצר בהצלחה',
                error: 'שגיאה ביצירת חשבונית',
            },
        },
        delete: {
            success: 'חשבונית נמחקה בהצלחה',
            error: 'שגיאה במחיקת חשבונית',
        },
        accountSelect: 'בחר אתר',
    },
    queue_jobs: {
        id: 'מזהה עבודה',
        name: 'שם',
        state: 'מצב',
        progress: 'התקדמות',
        attemptsMade: 'נסיונות',
        processedOn: 'עובד',
        finishedOn: 'הסתיים',
        failedReason: 'סיבת כישלון',
    },
    fault_logs: {
        _id: 'מזהה',
        account: 'אתר',
        meter: 'מונה',
        structure: 'מבנה',
        created: 'תאריך תקלה',
        message: 'סיבת תקלה',
        error: 'שגיאה',
        submit: {
            edit: {
                success: 'יומן תקלות עודכן בהצלחה',
                error: 'שגיאה בעדכון יומן תקלות',
            },
            create: {
                success: 'יומן תקלות נוצר בהצלחה',
                error: 'שגיאה ביצירת יומן תקלות',
            },
        },
        delete: {
            success: 'יומן תקלות נמחק בהצלחה',
            error: 'שגיאה במחיקת יומן תקלות',
        },
        accountSelect: 'בחר אתר',
        resolveFault: {
            success: 'תקלה נפתרה בהצלחה',
            error: 'שגיאה בפתרון התקלה',
        },
    },
    invites: {
        email: 'מייל',
        account: 'אתר',
        role: 'הרשאות',
        expireTime: 'זמן נותר',
        inviteUser: 'הזמן משתמש',
        sendAgainSuccess: 'הזמנה נשלחה בהצלחה',
        sendAgainError: 'שגיאה בשליחת הזמנה',
        accountSelect: 'בחר אתר',
        sendAgain: {
            success: 'ההזמנה נשלחה בהצלחה',
            error: 'שגיאה בשליחת ההזמנה',
        },
    },
    payments: {
        account: 'אתר',
        amount: 'סכום',
        currency: 'מטבע',
        created: 'תאריך יצירה',
        status: 'מצב',
        invoice: 'חשבונית',
        tokenExpiresAt: 'תפוגת טוקן',
        refreshToken: {
            confirm: 'האם ליצור טוקן תשלום חדש?',
            success: 'טוקן התשלום עודכן בהצלחה',
            error: 'שגיאה בעדכון טוקן התשלום',
        },
    },
    selectOptions: {
        manual: 'ידני',
        monthly: 'חודשי',
        bi_monthly: 'דו חודשי',
        pisga: 'פיסגה',
        sheffel: 'שפל',
        weekday: 'ימי חול',
        friday: 'ימי שישי וערבי חג',
        saturday: 'שבתות וחגים',
        OWNER: 'בעלים',
        ADMIN: 'מנהל',
        USER: 'משתמש',
        ACTIVE: 'פעיל',
        INACTIVE: 'לא פעיל',
        CANCELLED: 'מבוטל',
        pending: 'ממתין',
        paid: 'שולם',
        unpaid: 'לא שולם',
        general: 'כללי',
        water: 'מים',
        electricity: 'חשמל',
        gas: 'גז',
        constant: 'תעריף אחיד',
        geva: 'גבע',
        failed: 'נכשל',
        waiting: 'ממתין',
        active: 'פעיל',
        delayed: 'מושהה',
        completed: 'הושלם',
        auto: 'אוטומטי',
        GLOBAL: 'תעריף כללי',
        LOCAL: 'תעריך חשבון',
        error_saving_meter_reading_from_webhook: 'שגיאה בשמירת קריאת מונה',
        repeated_meter_failure_notification: 'הודעת תקלה חוזרת במונה',
        assigned: 'משוייך',
        success: 'בוצע בהצלחה',
        canceled: 'מבוטל',
    },
    date: {
        from: 'מתאריך',
        to: 'עד תאריך',
    },
    modal: {
        close_modal_title: 'האם אתה בטוח שברצונך לסגור?',
        confirm_close_modal: 'כן, סגור',
        modal_error_title: 'משהו השתבש!',
        confirm_title: 'שים לב',
        confirm_action: 'כן, אשר',
        delete_title: 'האם אתה בטוח שברצונך למחוק?',
        confirm_delete: 'אישור מחיקה',
        cancel: 'ביטול',
        clear: 'נקה',
        delete_success: 'נמחק בהצלחה',
        submit: 'אישור',
    },
    error: {
        Required: 'שדה חובה',
        required: 'שדה חובה',
        min: 'שדה חייב להיות באורך מינימלי של {min} תווים',
        max: 'שדה חייב להיות באורך מקסימלי של {max} תווים',
        email: 'אנא הזן כתובת מייל תקינה',
        password: 'הסיסמא חייבת להכיל לפחות 6 תווים',
        name: 'שם הוא שדה חובה',
        location: 'מיקום הוא שדה חובה',
        dayOfMonth: 'יום בחודש חייב להיות בין 1 ל-31',
        serviceRate: 'תעריף שירות חייב להיות בין 0 ל-100',
        account: 'אנא בחר אתר',
        structure: 'אנא בחר מבנה',
        meter: 'אנא בחר מונה',
        consumer: 'אנא בחר צרכן',
        rate: 'אנא בחר תעריף',
        value: 'אנא הזן ערך תקין',
        absolute_value: 'אנא הזן ערך מוחלט תקין',
        price: 'אנא הזן מחיר תקין',
        date: 'אנא הזן תאריך תקין',
        from_date: 'אנא הזן תאריך התחלה תקין',
        to_date: 'אנא הזן תאריך סיום תקין',
        phone: 'אנא הזן מספר טלפון תקין',
        role: 'אנא בחר הרשאה',
        status: 'אנא בחר מצב',
        type: 'אנא בחר סוג',
        category: 'אנא בחר קטגוריה',
        config_key_max: 'מפתח יכול להכיל עד 100 תווים',
        duplicate_config_key: 'המפתחות חייבים להיות ייחודיים (ללא תלות באותיות גדולות/קטנות)',
        charge_key_max: 'שם חיוב יכול להכיל עד 100 תווים',
        duplicate_charge_key: 'שמות החיובים חייבים להיות ייחודיים (ללא תלות באותיות גדולות/קטנות)',
    },
    signup: {
        title: 'הרשמה',
        submit: 'שלח',
        email: 'מייל',
        password: 'סיסמא',
        confirmPassword: 'אימות סיסמא',
        firstName: 'שם פרטי',
        lastName: 'שם משפחה',
        phone: 'טלפון',
        language: 'שפה',
        error: 'שגיאה בהרשמה',
        success: 'נרשמת בהצלחה',
    },
    forgotPassword: {
        title: 'איפוס סיסמא',
        submit: 'שלח',
        email: 'מייל',
        password: 'סיסמא',
        confirmPassword: 'אימות סיסמא',
        buttonNavigate: 'לחץ כאן להתחברות',
        success: 'לינק נשלח למייל שלך',
        welcome: 'הזינו את הפרטים שלכם.',
    },
    pullToRefresh: {
        pulling: 'משוך למטה לרענון',
        refreshing: 'מרענן...',
    },
    loading: 'טוען...',
    errors: {
        required: 'שדה חובה',
    },
    menuItems: {
        language: 'שפה',
        messages: 'הודעות',
        notifications: 'התראות',
        profile: 'פרופיל',
        queue: 'ניהול תורים',
        darkMode: 'מצב כהה',
        lightMode: 'מצב בהיר',
    },
    filters: {
        account: 'אתרים',
        structure: 'מבנים',
        meter: 'מונים',
        consumer: 'צרכנים',
        rate: 'תעריפים',
        user: 'משתמשים',
        category: 'קטגורית מונה',
        status: 'מצב',
        typeDay: 'סוג יום',
        isGlobal: 'תעריף כללי',
        taoz: 'תעוז',
        role: 'הרשאות',
        from_date: 'מתאריך',
        to_date: 'עד תאריך',
        date: 'תאריך',
        error: 'שגיאות',
        provider: 'ספק',
        allCategories: 'כל הקטגוריות',
        status_paid: 'מצב תשלום',
    },
    configs: {
        title: 'קונפיגורציה',
        key: 'מפתח',
        value: 'ערך',
    },
    settings: {
        general: 'כללי',
        info: 'מידע',
        queues: 'תורים',
        generalSettings: {
            rolloverValue: 'ערך גלגול',
            percentRolloverValue: 'אחוז גלגול',
            errors: 'שגיאות',
            numberOfReadingsFailure: 'מספר קריאות שנכשלו',
            numberOfDaysReadingsMissing: 'מספר ימים עם קריאות חסרות',
            queueEnabled: 'הפעלת עיבוד תורים',
        },
        queueManagement: {
            healthTitle: 'בריאות תורים',
            refresh: 'רענון',
            lastUpdated: 'עודכן לאחרונה',
            statusRunning: 'רץ',
            statusPaused: 'מושהה',
            waiting: 'בהמתנה',
            active: 'פעיל',
            failed: 'נכשל',
            completed: 'הושלם',
            jobsTitle: 'עבודות',
            selectQueue: 'בחר תור',
            stateFilter: 'מצבים',
            noJobs: 'אין עבודות להצגה',
            state: 'סטטוס',
            progress: 'התקדמות',
            attempts: 'נסיונות',
            processedOn: 'עובד',
            finishedOn: 'הסתיים',
            failedReason: 'סיבת כישלון',
            data: 'נתונים',
            filters: 'פילטרים',
            autoRefresh: 'רענון אוטומטי',
            completionRate: 'שיעור השלמה',
            queues: 'תורים',
            actions: {
                pause: 'השהה',
                resume: 'המשך',
                clear: 'נקה',
                cancel_job: 'בטל עבודה',
                retry_job: 'נסה שוב',
            },
            actionSuccess: 'הפקודה {{action}} נשלחה',
            actionError: 'נכשלה הפעולה {{action}}',
            cancelJobSuccess: 'העבודה בוטלה בהצלחה',
            cancelJobError: 'שגיאה בביטול העבודה',
            retryJobSuccess: 'העבודה הועברה לניסיון חוזר',
            retryJobError: 'שגיאה בניסיון החוזר',
        },
        submit: {
            edit: {
                success: 'הגדרות עודכנו בהצלחה',
                error: 'שגיאה בעדכון הגדרות',
            },
            create: {
                success: 'הגדרות נוצרו בהצלחה',
                error: 'שגיאה ביצירת הגדרות',
            },
        },
    },
    permissions: {
        title: 'הרשאות מותאמות',
        userLabel: 'משתמש',
        accountLabel: 'חשבון',
        roleLabel: 'תפקיד',
        roleFallback: 'לא הוגדר',
        resourcesLabel: 'משאב',
        unknownUser: 'משתמש לא ידוע',
        unknownAccount: 'חשבון לא ידוע',
        roleInheritance: 'נגזר מתפקיד {{role}}',
        superUserNotice:
            'למשתמש יש הרשאות סופר. ההגדרות משפיעות על הממשק בלבד ואינן עוקפות בדיקות בשרת.',
        noAccounts: 'יש לשייך את המשתמש לפחות לחשבון אחד כדי לנהל הרשאות.',
        loadError: 'נכשלה טעינת ההרשאות. נסו שוב.',
        currentValue: 'עדכנו את הפעולות המאושרות ולחצו שמירה.',
        searchPlaceholder: 'חפש משאבים',
        badges: {
            inherited: 'ברירת מחדל',
            override: 'התאמה ידנית',
            unsaved: 'שינויים בהמתנה',
            enabledCount: '{{enabled}}/{{total}} פעולות מאופשרות',
        },
        summary: {
            pendingChanges: '{{count}} משאבים עודכנו',
            noChanges: 'אין שינויים בהמתנה',
            enabledCount: '{{enabled}}/{{total}} פעולות',
        },
        emptyState: {
            noMatches: 'אין משאבים המתאימים לחיפוש.',
            selectResource: 'בחרו משאב להצגת ההרשאות.',
            missingCatalog: 'נתוני המשאב אינם זמינים.',
            noActions: 'אין פעולות זמינות למשאב זה.',
            noResources: 'אין משאבים לחשבון זה.',
        },
        confirm: {
            unsaved: 'יש שינויים שלא נשמרו. להמשיך בלי לשמור?',
        },
        actions: {
            save: 'שמור שינויים',
            clearOverride: 'חזרה לברירת המחדל',
            selectAll: 'אפשר הכל',
            clearAll: 'נטרל הכל',
            matchRole: 'התאם לברירת המחדל',
            saveAll: 'שמור הכל',
            discard: 'בטל שינויים',
        },
        actionLabels: {
            CREATE: 'יצירה',
            READ: 'צפייה',
            UPDATE: 'עדכון',
            DELETE: 'מחיקה',
            ADMIN: 'ניהול',
            OWNER: 'בעלות',
            SUPER: 'סופר',
        },
        resources: {
            USERS: 'משתמשים',
            ACCOUNTS: 'חשבונות',
            METERS_READING: 'קריאות מונה',
            INVOICES: 'חשבוניות',
            RATES: 'תעריפים',
            CONSUMERS: 'צרכנים',
            FAULT_LOG: 'יומן תקלות',
            CONFIGS: 'הגדרות',
            ACCOUNT_REPORTS: 'דוחות חשבון',
            INVITES: 'הזמנות',
            METERS: 'מונים',
            STRUCTURES: 'מבנים',
            PAYMENTS: 'תשלומים',
        },
        toast: {
            save: {
                success: 'ההרשאות עודכנו בהצלחה',
                error: 'עדכון ההרשאות נכשל',
            },
            reset: {
                success: 'ההרשאות חזרו לברירת המחדל',
                error: 'החזרה לברירת המחדל נכשלה',
            },
            bulk: {
                success: 'ההרשאות נשמרו',
                error: 'שמירת ההרשאות נכשלה',
            },
        },
    },
    paymentFlow: {
        title: 'תשלום חשבונית',
        subtitle: 'השלימו את התשלום בצורה מאובטחת באמצעות הטופס.',
        missingToken: 'קישור התשלום אינו תקף או שפג תוקפו. אנא פנו לתמיכה.',
        result: {
            pending: 'התשלום ממתין לעיבוד',
            success: 'התשלום הושלם',
            failed: 'התשלום נכשל',
            unknown: 'סטטוס התשלום אינו זמין',
        },
        iframe: {
            title: 'טופס תשלום מאובטח',
            subtitle: 'אם הטופס לא נטען, נסו לרענן את הדף או לנסות שוב מאוחר יותר.',
        },
        details: {
            paymentId: 'מספר תשלום',
            amount: 'סכום',
            invoice: 'חשבונית',
        },
        actions: {
            refresh: 'רענן סטטוס',
        },
        errors: {
            status: 'לא ניתן לטעון את נתוני התשלום.',
        },
    },
    save: 'שמור',
    profile: {
        title: 'פרופיל',
        image: 'העלת תמונה',
        saveChanges: 'שמור שינויים',
    },
    fromDialogActions: {
        overview: 'תצוגה מקדימה',
    },
    menuItem: {
        download: 'הורדה',
        update_value: 'עדכון ערך',
        send_again: 'שלח שוב',
        resend_invoice: 'שליחת חשבונית מחדש',
        cancel_invoice: 'בטל חשבונית',
        send_unpaid_invoices: 'שלח חשבוניות שלא שולמו',
        edit: 'עריכה',
        delete: 'מחיקה',
        resolve_fault: 'פתור תקלה',
        manage_permissions: 'ניהול הרשאות',
        open_payment: 'פתח תשלום',
        refresh_payment_token: 'רענן טוקן תשלום',
        sync_meter: 'סנכרן מונה',
        cancel_job: 'בטל עבודה',
        retry_job: 'נסה שוב',
    },
    failure_details: {
        rate: 'חסר תעריף',
        price: 'חסר מחיר',
        reading_exist: 'קריאה קיימת',
        absolute_value: 'חסר ערך מוחלט',
        invoice_date: 'חשבון נוצר',
    },
    table: {
        header: {
            filter: 'סינון',
            add: 'הוספה',
        },
    },
    additionalCharges: {
        chargeKey: 'שם חיוב',
        chargeValue: 'סכום חיוב',
    },
    notFound: {
        title: '404',
        subtitle: 'הדף לא נמצא',
        description: 'הדף שחיפשת אינו קיים או שהועבר למקום אחר.',
        backToDashboard: 'חזרה למסך הבית',
    },
}

export default he
